import angular from 'angular';

/**
 * Legacy module — preserved as empty so deps keep resolving.
 * Real implementation: apps/b2b-frontend/app/core/button-group-actions/button-group-actions.service.ts
 * Registered via downgradeInjectable in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 */
export { ButtonGroupActionsService } from '@ng/core/button-group-actions/button-group-actions.service';
export type { ButtonGroupAction } from '@ng/core/button-group-actions/button-group-actions.service';

export const ButtonGroupActionsServiceModule = angular.module('acme.common.service.button-group-actions', []).name;
